import React from 'react';

import './styles.scss';
import classNames from "classnames";

interface ButtonProps {
  children: any,
  onClick?: () => void,
  className?: string,
  isDisabled?: boolean,
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className,
  isDisabled,
}) => {
  return (
    <button
      className={classNames(`Button ${className}`, {
      "isDisabled": isDisabled,
      })}
      onClick={onClick}>{children}</button>
  );
};
